/**
 * PostHog Analytics Event
 *
 * Naming convention: snake_case, verb_object
 * No prefixes - use `source` property to indicate origin.
 */

export const AnalyticsEvents = {
  // ============================================================================
  // -------------------------- Auth --------------------------
  // ============================================================================

  // Track when a user views the set password page (only available to users coming from VSL)
  SET_VSL_PASSWORD_VIEWED: 'set_vsl_password_viewed',

  // Track when a user views the login page with query params
  LOGIN_VIEWED_FROM: 'login_viewed_from',

  // ============================================================================
  // -------------------------- Onboarding --------------------------
  // ============================================================================

  // Track when a user views an onboarding step, the frontend tracks views only; backend tracks completions.
  ONBOARDING_STEP_VIEWED: 'onboarding_step_viewed',

  // ============================================================================
  // -------------------------- KYC Verification --------------------------
  // ============================================================================

  // Track when a user views a KYC verification step (separate from onboarding)
  KYC_STEP_VIEWED: 'kyc_step_viewed',

  // ============================================================================
  // -------------------------- Paywall / Checkout --------------------------
  // ============================================================================

  // Track when a user views the pricing table, the frontend tracks views only; backend tracks completions.
  PRICING_TABLE_VIEWED: 'pricing_table_viewed',

  // Track when a user starts a credits topup, the frontend tracks starts only; backend tracks completions.
  CREDITS_TOPUP_STARTED: 'credits_topup_started',

  // ============================================================================
  // -------------------------- Reports --------------------------
  // ============================================================================

  // Track when a user initiates a report run, the frontend tracks initiations only; backend tracks completions.
  REPORT_RUN_INITIATED: 'report_run_initiated',
} as const

export type AnalyticsEvent =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents]
